import styled from "vue-styled-components";

export const Content = styled.div`
    label {
        margin-bottom: 0.3rem;
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        font: 600 1.5rem/1.1 ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
        letter-spacing: .005em;
        text-transform: capitalize;
    }

    div {
        display: flex;
        margin-bottom: 1rem;
        margin-right: 0.5rem;

        button {
            border: none;
            width: 2.5rem;
            height: 3.7rem;
            outline: none;
            cursor: pointer;
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};

            &:hover,
            &:focus {
                background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
                color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
                border: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            }

            &:first-child {
                border-radius: ${props => props.theme?.inputs?.border_radius ?? '0'} 0 0 ${props => props.theme?.inputs?.border_radius ?? '0'};
            }

            &:last-child {
                border-radius: 0 ${props => props.theme?.inputs?.border_radius ?? '0'} ${props => props.theme?.inputs?.border_radius ?? '0'} 0;
            }

            i {
                color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
                font-size: 1rem;
            }
        }

        input {
            border: none;
            background: ${props => props.theme?.inputs?.background_color ?? props.theme?.background_color_site ?? '#fff'};
            color: ${props => props.theme?.inputs?.color ?? '#21293c'};
            border-top: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            border-bottom: 1px solid ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            width: 5.5rem;
            height: 3.7rem;
            padding: 1rem .2rem;
            font-size: 1.4rem;
            letter-spacing: .05em;
            text-align: center;
            outline: none;

            &::placeholder {
                color: ${props => props.theme?.inputs?.color ?? '#4a505e'};
            }
        }
    }
`;
